import { VISIBLE_DIGITS } from "../data/constants";

export const obfuscateEmail = (email: string): string => {
  const [localPart, domain] = email.split("@");
  if (!localPart || !domain) return email;

  const obfuscatedLocal = localPart.slice(0, 3) + "****";
  const domainParts = domain.split(".");
  const domainName = domainParts[0];
  const domainExt = domainParts[1];

  if (!domainName || !domainExt) return email;

  const obfuscatedDomain = domainName[0] + "****";
  return `${obfuscatedLocal}@${obfuscatedDomain}.${domainExt}`;
};


export const obfuscatePhone = (
  phone: string | number,
  visibleDigits = VISIBLE_DIGITS,
  maskChar = "*"
): string => {
  if (!phone) return "";

  const phoneStr = phone.toString();
  const maskLength = Math.max(0, phoneStr.length - visibleDigits);
  const maskedPart = maskChar.repeat(maskLength);
  const visiblePart = phoneStr.slice(-visibleDigits);

  return maskedPart + visiblePart;
};